'use client';

/**
 * HandoffTimeoutOptions — entry view of the timeout-recovery flow
 * (HandoffPhase.TIMED_OUT). Presents the two recovery paths; the container
 * (handoff-timeout-panel.tsx) owns which view is currently showing.
 */
import { Mail } from 'lucide-react';
import { StandardCard } from './primitives/standard-card';
import { ClockIcon } from './primitives/handoff-icons';

interface HandoffTimeoutOptionsProps {
  onChooseMessage: () => void;
  onChooseCallback: () => void;
}

export function HandoffTimeoutOptions({
  onChooseMessage,
  onChooseCallback,
}: HandoffTimeoutOptionsProps) {
  return (
    <StandardCard
      tone="warn"
      icon={<ClockIcon />}
      eyebrow="NO AGENT AVAILABLE"
      title="Our guides are all busy right now"
    >
      <div className="flex flex-col gap-[14px]">
        <div>
          No one was able to join within a few minutes — sorry about that. Your
          details are saved, so you won&apos;t need to re-enter them. Pick
          whatever&apos;s easiest:
        </div>

        <div className="flex flex-wrap gap-[9px]">
          <button
            type="button"
            onClick={onChooseMessage}
            className="rounded-[22px] bg-[#E36001] px-[18px] py-[10px] text-[13.5px] font-semibold text-white shadow-[0_10px_22px_-12px_rgba(227,96,1,0.7)]"
          >
            Leave a message
          </button>
          <button
            type="button"
            onClick={onChooseCallback}
            className="rounded-[22px] border-[1px] border-[#F0D8BE] bg-white px-[18px] py-[10px] text-[13.5px] font-semibold text-[#E36001]"
          >
            Request a call-back
          </button>
        </div>

        <div
          className="flex items-center gap-[6px] text-[12.5px]"
          style={{ color: '#9a8f7f' }}
        >
          <Mail aria-hidden="true" className="size-[13px]" />
          We usually reply by email within a few hours.
        </div>
      </div>
    </StandardCard>
  );
}
